/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Mock_LabelInputs */

const en_dr_room_mock_label = /** @type {(inputs: Dr_Room_Mock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simulation · a salon booking room`)
};

const id_dr_room_mock_label = /** @type {(inputs: Dr_Room_Mock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simulasi · ruang booking salon`)
};

/**
* | output |
* | --- |
* | "Simulation · a salon booking room" |
*
* @param {Dr_Room_Mock_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_mock_label = /** @type {((inputs?: Dr_Room_Mock_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Mock_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_mock_label(inputs)
	return en_dr_room_mock_label(inputs)
});